var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 210,
    viewBox: "0 0 235 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4266 13.4051C119.145 -20.7723 188.104 14.5693 217.08 72.4281C246.055 130.287 218.461 184.112 141.924 189.631C63.3456 195.297 42.1952 192.585 17.2612 129.311C-7.02814 67.7014 18.4106 27.2315 47.4266 13.4051Z",
    fill: "#9747FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.762 7.71697L112.453 12.2461L116.982 14.5558L119.291 10.0267L114.762 7.71697Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.337 34.0752L120.203 39.4114L121.229 39.8218L123.364 34.4856L122.337 34.0752Z",
    fill: "#8B4500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.193 22.4937L141.151 22.1253C141.306 21.7267 141.38 21.3011 141.369 20.8734C141.358 20.4457 141.261 20.0246 141.084 19.6349C140.996 19.4426 140.869 19.2703 140.712 19.1284C140.555 18.9866 140.371 18.8781 140.171 18.8096C139.159 18.502 138.31 17.8067 137.809 16.8755C137.573 16.3881 137.439 15.8571 137.417 15.3158C137.395 14.7745 137.484 14.2344 137.68 13.7292L138.726 14.0977C138.579 14.4609 138.508 14.851 138.519 15.243C138.531 15.6351 138.624 16.0204 138.793 16.3744C139.157 17.0387 139.767 17.5344 140.491 17.756C140.835 17.8659 141.154 18.0447 141.427 18.2816C141.7 18.5185 141.922 18.8085 142.079 19.1338C142.323 19.6575 142.458 20.2249 142.478 20.8022C142.497 21.3794 142.401 21.9547 142.193 22.4937Z",
    fill: "#8B4500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6053 38.5382L27.3438 37.4624C27.7644 37.3792 28.164 37.2124 28.519 36.9719C28.874 36.7314 29.1772 36.4222 29.4105 36.0625C29.5224 35.8837 29.5968 35.6841 29.6291 35.4757C29.6614 35.2674 29.6509 35.0546 29.5984 34.8504C29.3171 33.8306 29.4495 32.7411 29.9668 31.8184C30.2486 31.356 30.6233 30.9571 31.0672 30.647C31.5111 30.3369 32.0146 30.1223 32.5457 30.0168L32.8036 31.0889C32.4178 31.1609 32.0512 31.3124 31.7271 31.5338C31.403 31.7551 31.1285 32.0415 30.921 32.3747C30.5591 33.0366 30.4679 33.8132 30.6668 34.5409C30.7609 34.8897 30.7822 35.2542 30.7296 35.6116C30.677 35.969 30.5516 36.3118 30.361 36.6188C30.0532 37.1065 29.6507 37.5277 29.1774 37.8574C28.7041 38.187 28.1696 38.4185 27.6053 38.5382Z",
    fill: "#8B4500"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.542 30.4377L159.635 25.4351L154.633 26.3415L155.539 31.3441L160.542 30.4377Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2733 34.534L55.5576 35.1348L55.6731 36.2339L61.3889 35.6332L61.2733 34.534Z",
    fill: "#8B4500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7117 18.6623L67.5459 17.5571C67.9712 17.5076 68.3825 17.374 68.7556 17.164C69.1288 16.954 69.4565 16.6718 69.7195 16.3339C69.848 16.1665 69.9411 15.9746 69.993 15.77C70.0449 15.5655 70.0547 15.3524 70.0216 15.144C69.8234 14.1064 70.0432 13.0325 70.6332 12.1562C70.9533 11.719 71.3604 11.3529 71.829 11.0809C72.2976 10.8089 72.8174 10.6369 73.3557 10.5757L73.5252 11.6809C73.1357 11.7174 72.758 11.8345 72.4162 12.0248C72.0743 12.2151 71.7758 12.4743 71.5395 12.7861C71.1225 13.4163 70.9667 14.1837 71.1047 14.9266C71.1679 15.2821 71.1579 15.6467 71.0756 15.9982C70.9933 16.3497 70.8402 16.6808 70.6258 16.9713C70.2784 17.4342 69.8413 17.8225 69.3407 18.113C68.84 18.4035 68.286 18.5903 67.7117 18.6623Z",
    fill: "#8B4500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9466 13.4197H90.8176C90.2418 13.3753 89.6809 13.2153 89.1682 12.9495C88.6555 12.6837 88.2016 12.3174 87.8335 11.8724L88.6624 11.1356C88.9334 11.4692 89.2687 11.7449 89.6485 11.9462C90.0282 12.1475 90.4447 12.2702 90.8729 12.3071C91.0836 12.3246 91.2956 12.2994 91.4963 12.2329C91.697 12.1664 91.8822 12.0601 92.0407 11.9203C92.8069 11.1904 93.8306 10.7931 94.8886 10.8151C95.4294 10.8488 95.9575 10.9942 96.4394 11.2421C96.9213 11.49 97.3466 11.8351 97.6885 12.2556L96.8559 12.9924C96.6135 12.684 96.3094 12.4296 95.963 12.2456C95.6166 12.0616 95.2356 11.9521 94.8443 11.924C94.0886 11.9123 93.358 12.195 92.807 12.7124C92.3041 13.1838 91.6356 13.4379 90.9466 13.4197Z",
    fill: "#8B4500"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1352 34.935L82.1382 31.8008L79.0039 27.7978L75.0009 30.932L78.1352 34.935Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.648 48.7505H0.863281V112.253H56.648V48.7505Z",
    fill: "#282344"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4404 84.4016L53.0079 107.206L46.6455 80.6033L32.3843 86.9805C32.3843 86.9805 29.2786 125.174 46.3397 131.035C69.6969 139.059 78.4909 89.9425 78.4909 89.9425L59.4404 84.4016Z",
    fill: "#8B4500"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8464 76.5654C36.3345 71.625 28.7415 67.4178 28.0047 70.0924C27.2679 72.7671 40.5307 80.6621 40.5307 80.6621L43.8464 76.5654Z",
    fill: "#9747FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3467 85.2746C47.544 76.3591 47.194 69.9782 44.453 70.4572C41.7121 70.9361 41.0747 85.3446 41.0747 85.3446L46.3467 85.2746Z",
    fill: "#9747FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0355 82.1541C39.5199 77.2138 30.8623 73.4339 30.0886 76.1085C29.3149 78.7832 44.7992 86.9361 44.7992 86.9361L47.0355 82.1541Z",
    fill: "#9747FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8613 80.2864C40.4925 78.8128 33.2827 74.3477 31.1348 75.6813L30.5527 74.7419C32.4685 73.5556 36.322 74.9334 43.4471 79.3507L42.8613 80.2864Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3011 86.7225C37.7892 81.7821 29.1279 78.0022 28.3542 80.6769C27.5806 83.3515 43.0649 91.5045 43.0649 91.5045L45.3011 86.7225Z",
    fill: "#9747FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1076 84.8695C38.7388 83.3958 31.529 78.9307 29.3848 80.2643L28.8027 79.3249C30.7148 78.1386 34.5684 79.5165 41.6971 83.93L41.1076 84.8695Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M233.491 95.1921L217.078 72.4281C216.351 71.4209 215.418 70.5802 214.341 69.9618C213.264 69.3434 212.067 68.9615 210.831 68.8416C209.595 68.7217 208.347 68.8665 207.171 69.2664C205.995 69.6663 204.918 70.312 204.011 71.1607L204.449 71.4849C213.475 78.3742 216.946 89.806 214.676 94.1937C219.607 97.1061 225.073 98.9967 230.75 99.753C231.311 99.8277 231.881 99.7368 232.39 99.4915C232.9 99.2463 233.327 98.8573 233.618 98.3725C233.909 97.8878 234.052 97.3284 234.03 96.7633C234.007 96.1983 233.82 95.6521 233.491 95.1921Z",
    fill: "#FF7C5E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M204.45 71.4702L204.012 71.146L203.953 71.2013L201.547 73.4928C201.547 73.4928 204.94 86.4203 208.362 89.5149C210.308 91.2749 212.423 92.8372 214.677 94.179C216.946 89.806 213.476 78.3742 204.45 71.4702Z",
    fill: "#FF7C5E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M148.202 61.8657C148.202 61.8657 171.588 98.6036 173.766 105.847L201.599 73.8206L214.125 92.7754C214.125 92.7754 171.084 159.458 155.069 154.937C139.054 150.417 127.254 107.173 125.113 100.044L116.913 72.7596L148.202 61.8657Z",
    fill: "#8B4500"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M225.039 145.34L221.009 117.323C220.837 116.115 220.408 114.958 219.752 113.93C219.095 112.902 218.225 112.027 217.202 111.364C216.178 110.7 215.024 110.264 213.817 110.085C212.611 109.905 211.38 109.986 210.207 110.323L210.049 110.367C210.13 110.522 210.207 110.684 210.288 110.857C215.077 121.147 212.867 132.884 208.814 135.721C211.834 140.589 215.804 144.799 220.486 148.1C220.947 148.428 221.494 148.614 222.06 148.635C222.626 148.656 223.186 148.511 223.67 148.217C224.154 147.924 224.542 147.495 224.785 146.984C225.029 146.473 225.117 145.901 225.039 145.34Z",
    fill: "#FF7C5E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M210.287 110.89C210.206 110.717 210.128 110.555 210.047 110.4L206.776 111.34C206.776 111.34 203.792 124.367 205.394 128.696C206.303 131.156 207.452 133.52 208.824 135.754C212.869 132.899 215.091 121.162 210.287 110.89Z",
    fill: "#FF7C5E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M147.14 64.9788L156.409 129.609L206.804 111.376V131.119C206.804 131.119 146.79 169.309 131.626 162.468C116.462 155.626 115.21 140.267 114.153 132.903C113.095 125.538 106.316 76.7458 106.316 76.7458L147.14 64.9788Z",
    fill: "#8B4500"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3355 74.3918C42.2117 73.9024 39.9905 74.0537 37.9528 74.8267C35.915 75.5997 34.1522 76.9596 32.8874 78.7344C31.6225 80.5093 30.9124 82.6193 30.8468 84.7978C30.7812 86.9762 31.363 89.1252 32.5188 90.9729C33.6745 92.8207 35.3522 94.2842 37.3398 95.1784C39.3273 96.0726 41.5354 96.3574 43.6847 95.9967C45.8341 95.636 47.8282 94.646 49.4149 93.1519C51.0017 91.6578 52.1097 89.7268 52.5989 87.603C53.2539 84.7554 52.7514 81.7642 51.2018 79.2869C49.6523 76.8096 47.1826 75.0489 44.3355 74.3918Z",
    fill: "#8B4500"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9778 92.5028L38.8726 92.3149C39.2764 90.327 40.1464 88.4634 41.4109 86.8772L42.2583 87.5882C41.1269 89.0272 40.3461 90.7098 39.9778 92.5028Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8533 91.5303C49.6427 91.5303 50.2827 90.8903 50.2827 90.1008C50.2827 89.3114 49.6427 88.6714 48.8533 88.6714C48.0638 88.6714 47.4238 89.3114 47.4238 90.1008C47.4238 90.8903 48.0638 91.5303 48.8533 91.5303Z",
    fill: "#FF7C5E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5661 93.9175C47.5661 93.9175 47.4556 97.3437 46.5088 97.6421C45.8125 97.8632 44.0367 96.9532 41.8484 96.4374C35.9538 95.0411 34.3696 92.2007 34.3696 92.2007",
    fill: "#8B4500"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2557 98.2316C45.5174 98.1534 44.7941 97.9698 44.1079 97.6864C43.3968 97.4506 42.5937 97.178 41.7243 96.9753C35.6639 95.5422 33.9582 92.5949 33.8882 92.4697C33.8163 92.3417 33.7983 92.1904 33.838 92.0491C33.8778 91.9078 33.972 91.7881 34.1 91.7163C34.228 91.6445 34.3793 91.6264 34.5206 91.6662C34.6619 91.7059 34.7816 91.8001 34.8534 91.9281C34.8534 91.9539 36.4412 94.588 41.9785 95.8996C42.8958 96.1169 43.7284 96.3933 44.4579 96.6364C45.1873 96.8796 46.1046 97.189 46.3441 97.1117C46.6352 96.9385 46.9667 95.3728 47.0146 93.8991C47.0168 93.8265 47.0332 93.7551 47.063 93.6889C47.0928 93.6227 47.1353 93.563 47.1882 93.5132C47.2411 93.4634 47.3032 93.4246 47.3711 93.3988C47.439 93.373 47.5112 93.3609 47.5838 93.3631C47.6564 93.3653 47.7278 93.3817 47.794 93.4115C47.8602 93.4413 47.9199 93.4838 47.9697 93.5367C48.0195 93.5895 48.0584 93.6517 48.0841 93.7195C48.1099 93.7874 48.122 93.8597 48.1199 93.9323C48.083 95.0817 47.8693 97.7895 46.6757 98.1653C46.5403 98.2106 46.3984 98.233 46.2557 98.2316Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M101.646 78.0023C103.569 116.096 110.241 133.883 110.241 142.625C110.241 142.625 115.303 136.071 126.348 136.933C137.393 137.795 139.644 135.78 142.145 132.807C148.357 125.439 156.41 129.609 156.41 129.609C156.41 129.609 165.62 80.7395 148.202 61.8659C137.433 50.1983 127.265 50.3641 111.387 52.8914L101.646 78.0023Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M114.61 45.991C88.9133 49.5203 53.5237 62.4405 55.5979 86.9435C57.672 111.446 106.317 105.825 106.317 105.825C106.317 105.825 102.585 96.6143 113.133 87.9271C120.681 81.7157 114.606 80.3563 117.859 73.2165C124.303 59.0806 106.317 53.3408 114.61 45.991Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 96.9348H125.55V110.64H137.785V96.9348Z",
    fill: "#FF7C5E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 63.6304H140.732V77.3352H152.967V63.6304Z",
    fill: "#FF7C5E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2349 146.895H80V160.6H92.2349V146.895Z",
    fill: "#FF7C5E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M168.149 80.2827H155.914V93.9876H168.149V80.2827Z",
    fill: "#FF7C5E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M183.335 130.243H171.101V143.948H183.335V130.243Z",
    fill: "#FF7C5E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M107.42 163.547H95.1851V177.252H107.42V163.547Z",
    fill: "#FF7C5E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0528 146.895H64.8179V160.6H77.0528V146.895Z",
    fill: "#FF7C5E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M183.335 96.9348H171.101V110.64H183.335V96.9348Z",
    fill: "#FF7C5E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8179 163.547V166.697C68.7672 167.802 72.9229 169.047 77.0528 170.481V163.547H64.8179Z",
    fill: "#FF7C5E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M168.149 146.895H155.914V160.6H168.149V146.895Z",
    fill: "#FF7C5E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M122.604 113.587H110.369V127.292H122.604V113.587Z",
    fill: "#FF7C5E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M80 163.547V171.534C84.1766 173.059 88.2595 174.83 92.2275 176.836V163.547H80Z",
    fill: "#FF7C5E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 209.808C156.865 209.945 157.388 210 157.388 210C156.745 205.619 156.412 201.198 156.394 196.77H155.911L155.915 209.808Z",
    fill: "#FF7C5E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M171.101 158.942C175.12 154.565 178.436 150.642 181.383 146.895H171.101V158.942Z",
    fill: "#FF7C5E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M155.914 177.252H158.784C160.177 172.573 162.313 168.219 165.526 164.877L166.797 163.547H155.914V177.252Z",
    fill: "#FF7C5E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 196.77V206.515C144.759 207.666 148.843 208.608 152.967 209.337V196.77H140.732Z",
    fill: "#FF7C5E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M155.914 193.823H156.422C156.5 189.238 157.033 184.672 158.014 180.192H155.914V193.823Z",
    fill: "#FF7C5E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M122.604 180.199H110.369V191.222C111.408 192.133 112.483 193 113.593 193.823H122.604V180.199Z",
    fill: "#FF7C5E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1001 180.199C101.162 182.189 103.799 184.336 105.8 186.654C106.323 187.262 106.865 187.851 107.421 188.43V180.199H98.1001Z",
    fill: "#FF7C5E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 196.77V200.885C129.519 202.735 133.606 204.319 137.785 205.627V196.785L125.55 196.77Z",
    fill: "#FF7C5E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M117.927 196.77C119.456 197.721 121.022 198.612 122.602 199.427V196.77H117.927Z",
    fill: "#FF7C5E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M186.283 140.238C188.567 136.962 190.648 133.695 192.723 130.243H186.283V140.238Z",
    fill: "#FF7C5E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 130.243H140.732V143.948H152.967V130.243Z",
    fill: "#FF7C5E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 113.587H140.732V127.292H152.967V113.587Z",
    fill: "#FF7C5E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M168.149 113.587H155.914V127.292H168.149V113.587Z",
    fill: "#FF7C5E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 130.243H125.55V143.948H137.785V130.243Z",
    fill: "#FF7C5E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 163.547H125.55V177.252H137.785V163.547Z",
    fill: "#FF7C5E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M122.604 163.547H110.369V177.252H122.604V163.547Z",
    fill: "#FF7C5E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M142.944 41.9016C142.362 42.5583 141.847 43.2702 141.404 44.0273H144.237C143.393 42.6716 142.944 41.9016 142.944 41.9016Z",
    fill: "#FF7C5E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M183.335 113.587H171.101V127.292H183.335V113.587Z",
    fill: "#FF7C5E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M122.604 146.895H110.369V160.6H122.604V146.895Z",
    fill: "#FF7C5E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 146.895H125.55V160.6H137.785V146.895Z",
    fill: "#FF7C5E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M122.604 130.243H110.369V143.948H122.604V130.243Z",
    fill: "#FF7C5E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 113.587H125.55V127.292H137.785V113.587Z",
    fill: "#FF7C5E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 80.2827H140.732V93.9876H152.967V80.2827Z",
    fill: "#FF7C5E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 96.9348H140.732V110.64H152.967V96.9348Z",
    fill: "#FF7C5E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M107.42 146.895H95.1851V160.6H107.42V146.895Z",
    fill: "#FF7C5E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M107.42 130.243H95.1851V143.948H107.42V130.243Z",
    fill: "#FF7C5E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M168.149 96.9348H155.914V110.64H168.149V96.9348Z",
    fill: "#FF7C5E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 180.199H125.55V193.823H137.785V180.199Z",
    fill: "#FF7C5E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 146.895H140.732V160.6H152.967V146.895Z",
    fill: "#FF7C5E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 163.547H140.732V177.252H152.967V163.547Z",
    fill: "#FF7C5E"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M168.149 130.243H155.914V143.948H168.149V130.243Z",
    fill: "#FF7C5E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 180.199H140.732V193.823H152.967V180.199Z",
    fill: "#FF7C5E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8704 143.31L60.8462 143.933H61.8704V143.31Z",
    fill: "#FF7C5E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M155.914 77.3353H168.153V75.5227C164.469 71.5439 161.039 67.484 158.003 63.6194H155.914V77.3353Z",
    fill: "#FF7C5E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0528 143.948V134.837C72.5213 137.234 68.443 139.483 64.8179 141.583V143.948H77.0528Z",
    fill: "#FF7C5E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2279 143.948V130.243H85.8544C85.1175 130.611 84.3807 131.009 83.6439 131.396C82.3913 132.041 81.1829 132.667 79.9893 133.289V143.948H92.2279Z",
    fill: "#FF7C5E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 60.6832H152.967V56.9659C150.119 53.0497 147.809 49.5977 146.103 46.9746H140.732V60.6832Z",
    fill: "#FF7C5E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 51.0603C136.679 53.5802 135.405 56.7412 134.027 60.6832H137.785V51.0603Z",
    fill: "#FF7C5E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M171.101 93.9874H183.335V93.4164L181.888 88.4171C178.709 85.8578 175.663 83.1378 172.762 80.2678H171.101V93.9874Z",
    fill: "#FF7C5E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M188.335 110.64L186.283 103.566V110.64H188.335Z",
    fill: "#FF7C5E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8707 163.547H52.0894C54.9887 164.188 58.3155 164.977 61.8707 165.905V163.547Z",
    fill: "#FF7C5E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8714 146.895H56.1978C48.4612 152.005 43.7272 156.374 41.4614 160.6H61.8714V146.895Z",
    fill: "#FF7C5E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M107.421 127.295V116.243C103.569 119.459 99.4748 122.373 95.1748 124.96V127.295H107.421Z",
    fill: "#FF7C5E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M186.283 127.295H193.172L189.193 113.587H186.283V127.295Z",
    fill: "#FF7C5E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M122.603 96.9348H122.234C119.968 101.947 116.928 106.571 113.227 110.64H122.592L122.603 96.9348Z",
    fill: "#FF7C5E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2282 126.732L91.2261 127.31H92.2282V126.732Z",
    fill: "#FF7C5E"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M137.786 63.6304H133.026C132.134 66.3124 131.206 69.3076 130.244 72.6527C129.78 74.2627 129.338 75.8211 128.903 77.3352H137.786V63.6304Z",
    fill: "#FF7C5E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 93.9876V80.2827H128.051C127.222 83.1305 126.412 85.8089 125.55 88.3877V93.9876H137.785Z",
    fill: "#FF7C5E"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8184 146.895H61.8711V160.6H64.8184V146.895Z",
    fill: "#4060FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8711 163.547V165.905C62.8388 166.151 63.8212 166.415 64.8184 166.697V163.547H61.8711Z",
    fill: "#4060FF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8184 143.948V141.583C63.8016 142.177 62.8191 142.758 61.8711 143.325V143.948H64.8184Z",
    fill: "#4060FF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0532 163.547V170.481C78.0406 170.82 79.0242 171.173 80.0005 171.534V163.547H77.0532Z",
    fill: "#4060FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0005 143.948V133.29L77.0532 134.837V143.948H80.0005Z",
    fill: "#4060FF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0005 146.895H77.0532V160.6H80.0005V146.895Z",
    fill: "#4060FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1856 146.895H92.2383V160.6H95.1856V146.895Z",
    fill: "#4060FF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1753 127.295V124.96C94.2248 125.542 93.2424 126.128 92.228 126.717V127.295H95.1753Z",
    fill: "#4060FF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1753 163.547H92.228V176.836L93.0422 177.259H95.1753V163.547Z",
    fill: "#4060FF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1856 130.243H92.2383V143.948H95.1856V130.243Z",
    fill: "#4060FF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M110.368 130.243H107.42V143.948H110.368V130.243Z",
    fill: "#4060FF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M110.368 163.547H107.42V177.252H110.368V163.547Z",
    fill: "#4060FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M110.368 127.295V113.587C109.444 114.476 108.462 115.361 107.42 116.243V127.295H110.368Z",
    fill: "#4060FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M107.42 180.199V188.43C108.36 189.402 109.347 190.331 110.368 191.222V180.199H107.42Z",
    fill: "#4060FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M110.368 146.895H107.42V160.6H110.368V146.895Z",
    fill: "#4060FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 130.243H122.603V143.948H125.55V130.243Z",
    fill: "#4060FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 163.547H122.603V177.252H125.55V163.547Z",
    fill: "#4060FF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M125.551 88.3877C124.902 90.3219 124.224 92.1823 123.491 93.9875H125.551V88.3877Z",
    fill: "#4060FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 113.587H122.603V127.292H125.55V113.587Z",
    fill: "#4060FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 146.895H122.603V160.6H125.55V146.895Z",
    fill: "#4060FF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 180.199H122.603V193.823H125.55V180.199Z",
    fill: "#4060FF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 96.9348H122.603V110.64H125.55V96.9348Z",
    fill: "#4060FF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M122.603 196.77V199.427C123.585 199.935 124.567 200.426 125.55 200.9V196.77H122.603Z",
    fill: "#4060FF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 130.243H137.785V143.948H140.732V130.243Z",
    fill: "#4060FF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 60.6832V46.9746H139.752C139.17 48.0798 138.518 49.4503 137.803 51.0603V60.6832H140.732Z",
    fill: "#4060FF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 163.547H137.785V177.252H140.732V163.547Z",
    fill: "#4060FF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 63.6304H137.785V77.3352H140.732V63.6304Z",
    fill: "#4060FF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 113.587H137.785V127.292H140.732V113.587Z",
    fill: "#4060FF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 196.77V205.612C138.787 205.929 139.77 206.225 140.732 206.5V196.77H137.785Z",
    fill: "#4060FF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 80.2827H137.785V93.9876H140.732V80.2827Z",
    fill: "#4060FF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 96.9348H137.785V110.64H140.732V96.9348Z",
    fill: "#4060FF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 146.895H137.785V160.6H140.732V146.895Z",
    fill: "#4060FF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 180.199H137.785V193.823H140.732V180.199Z",
    fill: "#4060FF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M155.727 60.6831C154.761 59.4084 153.842 58.1693 152.967 56.9658V60.6831H155.727Z",
    fill: "#4060FF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 146.895H152.967V160.6H155.915V146.895Z",
    fill: "#4060FF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 113.587H152.967V127.292H155.915V113.587Z",
    fill: "#4060FF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 130.243H152.967V143.948H155.915V130.243Z",
    fill: "#4060FF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 63.6304H152.967V77.3352H155.915V63.6304Z",
    fill: "#4060FF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 96.9348H152.967V110.64H155.915V96.9348Z",
    fill: "#4060FF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 180.199H152.967V193.823H155.915V180.199Z",
    fill: "#4060FF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 163.547H152.967V177.252H155.915V163.547Z",
    fill: "#4060FF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 80.2827H152.967V93.9876H155.915V80.2827Z",
    fill: "#4060FF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 196.77V209.337C154.179 209.55 155.178 209.705 155.915 209.808V196.77H152.967Z",
    fill: "#4060FF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M171.101 96.9348H168.154V110.64H171.101V96.9348Z",
    fill: "#4060FF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M171.101 130.243H168.154V143.948H171.101V130.243Z",
    fill: "#4060FF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M169.856 77.3352C169.281 76.7384 168.714 76.1379 168.154 75.5337V77.3352H169.856Z",
    fill: "#4060FF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M168.154 146.895V160.6H169.569C170.092 160.04 170.6 159.494 171.101 158.942V146.895H168.154Z",
    fill: "#4060FF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M171.101 80.2827H168.154V93.9876H171.101V80.2827Z",
    fill: "#4060FF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M171.101 113.587H168.154V127.292H171.101V113.587Z",
    fill: "#4060FF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M186.283 113.587H183.336V127.292H186.283V113.587Z",
    fill: "#4060FF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M183.502 93.9875L183.336 93.4165V93.9875H183.502Z",
    fill: "#4060FF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M183.336 110.64H186.283V103.566L184.356 96.9348H183.336V110.64Z",
    fill: "#4060FF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M183.336 130.243V143.948H183.612C184.536 142.702 185.426 141.466 186.283 140.238V130.243H183.336Z",
    fill: "#4060FF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M146.103 46.9746C145.367 45.8141 144.726 44.8194 144.236 44.0273H141.402C141.2 44.3552 140.975 44.7273 140.732 45.1326V46.9746H146.103Z",
    fill: "#4060FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M140.733 45.1472C140.427 45.6777 140.095 46.2819 139.734 46.9893H140.733V45.1472Z",
    fill: "#4060FF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M158.003 63.6304C157.283 62.7167 156.587 61.8166 155.914 60.9299V63.6304H158.003Z",
    fill: "#4060FF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 60.6831H134.027C133.7 61.6189 133.366 62.6013 133.025 63.6304H137.785V60.6831Z",
    fill: "#4060FF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 60.6831H140.732V63.6304H152.967V60.6831Z",
    fill: "#4060FF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 60.6831H137.785V63.6304H140.732V60.6831Z",
    fill: "#4060FF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 63.6304H155.915V60.9299L155.727 60.6831H152.967V63.6304Z",
    fill: "#4060FF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 77.3354H140.732V80.2827H152.967V77.3354Z",
    fill: "#4060FF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 77.3354H128.902C128.615 78.3375 128.335 79.3175 128.051 80.2827H137.785V77.3354Z",
    fill: "#4060FF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M172.762 80.2826C172.202 79.73 171.657 79.1774 171.101 78.6174V80.2826H172.762Z",
    fill: "#4060FF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M168.149 77.3354H155.914V80.2827H168.149V77.3354Z",
    fill: "#4060FF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 77.3354H137.785V80.2827H140.732V77.3354Z",
    fill: "#4060FF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 77.3354H152.967V80.2827H155.915V77.3354Z",
    fill: "#4060FF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M168.154 80.2827H171.101V78.6175C170.681 78.1902 170.266 77.7628 169.856 77.3354H168.154V80.2827Z",
    fill: "#4060FF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 93.9875H140.732V96.9348H152.967V93.9875Z",
    fill: "#4060FF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M168.149 93.9875H155.914V96.9348H168.149V93.9875Z",
    fill: "#4060FF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M183.335 93.9875H171.101V96.9348H183.335V93.9875Z",
    fill: "#4060FF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 93.9875H125.55V96.9348H137.785V93.9875Z",
    fill: "#4060FF"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M122.603 96.0874C122.478 96.3711 122.349 96.6547 122.235 96.9347H122.603V96.0874Z",
    fill: "#4060FF"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 96.9348V93.9875H123.49C123.203 94.6949 122.907 95.3949 122.603 96.0875V96.9348H125.55Z",
    fill: "#4060FF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 93.9875H137.785V96.9348H140.732V93.9875Z",
    fill: "#4060FF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 93.9875H152.967V96.9348H155.915V93.9875Z",
    fill: "#4060FF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M171.101 93.9875H168.154V96.9348H171.101V93.9875Z",
    fill: "#4060FF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M183.336 96.9348H184.356L183.502 93.9875H183.336V96.9348Z",
    fill: "#4060FF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 110.64H125.55V113.587H137.785V110.64Z",
    fill: "#4060FF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M186.283 113.587H189.193L188.335 110.64H186.283V113.587Z",
    fill: "#4060FF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M168.149 110.64H155.914V113.587H168.149V110.64Z",
    fill: "#4060FF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M122.603 113.587V110.64H113.227C112.333 111.622 111.376 112.605 110.357 113.587H122.592H122.603Z",
    fill: "#4060FF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M183.335 110.64H171.101V113.587H183.335V110.64Z",
    fill: "#4060FF"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 110.64H140.732V113.587H152.967V110.64Z",
    fill: "#4060FF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M110.368 113.583L110.364 113.587H110.368V113.583Z",
    fill: "#4060FF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 110.64H122.603V113.587H125.55V110.64Z",
    fill: "#4060FF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 110.64H137.785V113.587H140.732V110.64Z",
    fill: "#4060FF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 110.64H152.967V113.587H155.915V110.64Z",
    fill: "#4060FF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M171.101 110.64H168.154V113.587H171.101V110.64Z",
    fill: "#4060FF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M186.283 110.64H183.336V113.587H186.283V110.64Z",
    fill: "#4060FF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M168.149 127.295H155.914V130.243H168.149V127.295Z",
    fill: "#4060FF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 127.295H140.732V130.243H152.967V127.295Z",
    fill: "#4060FF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M92.228 127.295H91.2259C89.5263 128.266 87.7358 129.248 85.8545 130.243H92.228V127.295Z",
    fill: "#4060FF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M186.283 130.243H192.723C193.014 129.753 193.308 129.263 193.599 128.769L193.172 127.295H186.283V130.243Z",
    fill: "#4060FF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M183.335 127.295H171.101V130.243H183.335V127.295Z",
    fill: "#4060FF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M122.604 127.295H110.369V130.243H122.604V127.295Z",
    fill: "#4060FF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 127.295H125.55V130.243H137.785V127.295Z",
    fill: "#4060FF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M107.42 127.295H95.1851V130.243H107.42V127.295Z",
    fill: "#4060FF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1856 127.295H92.2383V130.243H95.1856V127.295Z",
    fill: "#4060FF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M110.368 127.295H107.42V130.243H110.368V127.295Z",
    fill: "#4060FF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 127.295H122.603V130.243H125.55V127.295Z",
    fill: "#4060FF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 127.295H137.785V130.243H140.732V127.295Z",
    fill: "#4060FF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 127.295H152.967V130.243H155.915V127.295Z",
    fill: "#4060FF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M171.101 127.295H168.154V130.243H171.101V127.295Z",
    fill: "#4060FF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M186.283 127.295H183.336V130.243H186.283V127.295Z",
    fill: "#4060FF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 143.948H140.732V146.895H152.967V143.948Z",
    fill: "#4060FF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M171.101 143.948V146.895H181.383C182.061 146.026 182.718 145.166 183.354 144.316V143.948H171.101Z",
    fill: "#4060FF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 143.948H125.55V146.895H137.785V143.948Z",
    fill: "#4060FF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8703 143.948H60.8461C59.1883 144.957 57.6385 145.94 56.1968 146.895H61.8703V143.948Z",
    fill: "#4060FF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M168.149 143.948H155.914V146.895H168.149V143.948Z",
    fill: "#4060FF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0528 143.948H64.8179V146.895H77.0528V143.948Z",
    fill: "#4060FF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M107.42 143.948H95.1851V146.895H107.42V143.948Z",
    fill: "#4060FF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2349 143.948H80V146.895H92.2349V143.948Z",
    fill: "#4060FF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M122.604 143.948H110.369V146.895H122.604V143.948Z",
    fill: "#4060FF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8184 143.948H61.8711V146.895H64.8184V143.948Z",
    fill: "#4060FF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0005 143.948H77.0532V146.895H80.0005V143.948Z",
    fill: "#4060FF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1856 143.948H92.2383V146.895H95.1856V143.948Z",
    fill: "#4060FF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M110.368 143.948H107.42V146.895H110.368V143.948Z",
    fill: "#4060FF"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 143.948H122.603V146.895H125.55V143.948Z",
    fill: "#4060FF"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 143.948H137.785V146.895H140.732V143.948Z",
    fill: "#4060FF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 143.948H152.967V146.895H155.915V143.948Z",
    fill: "#4060FF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M171.101 143.948H168.154V146.895H171.101V143.948Z",
    fill: "#4060FF"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M183.336 144.316L183.612 143.948H183.336V144.316Z",
    fill: "#4060FF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 160.6H140.732V163.547H152.967V160.6Z",
    fill: "#4060FF"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8705 160.6H41.4642C41.3242 160.861 41.1953 161.119 41.0737 161.377C41.0737 161.377 45.4947 162.092 52.0892 163.547H61.8705V160.6Z",
    fill: "#4060FF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M155.914 160.6V163.547H166.797L168.153 162.118V160.6H155.914Z",
    fill: "#4060FF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 160.6H125.55V163.547H137.785V160.6Z",
    fill: "#4060FF"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M107.42 160.6H95.1851V163.547H107.42V160.6Z",
    fill: "#4060FF"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M122.604 160.6H110.369V163.547H122.604V160.6Z",
    fill: "#4060FF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0528 160.6H64.8179V163.547H77.0528V160.6Z",
    fill: "#4060FF"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2349 160.6H80V163.547H92.2349V160.6Z",
    fill: "#4060FF"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8184 160.6H61.8711V163.547H64.8184V160.6Z",
    fill: "#4060FF"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0005 160.6H77.0532V163.547H80.0005V160.6Z",
    fill: "#4060FF"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1856 160.6H92.2383V163.547H95.1856V160.6Z",
    fill: "#4060FF"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M110.368 160.6H107.42V163.547H110.368V160.6Z",
    fill: "#4060FF"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 160.6H122.603V163.547H125.55V160.6Z",
    fill: "#4060FF"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 160.6H137.785V163.547H140.732V160.6Z",
    fill: "#4060FF"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 160.6H152.967V163.547H155.915V160.6Z",
    fill: "#4060FF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M168.154 162.118L169.569 160.6H168.154V162.118Z",
    fill: "#4060FF"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 177.252H125.55V180.199H137.785V177.252Z",
    fill: "#4060FF"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M155.914 180.199H158.014C158.24 179.217 158.497 178.234 158.784 177.252H155.914V180.199Z",
    fill: "#4060FF"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M107.421 177.252H95.1748V178.427C96.1818 179.002 97.1532 179.593 98.0889 180.199H107.41L107.421 177.252Z",
    fill: "#4060FF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M122.604 177.252H110.369V180.199H122.604V177.252Z",
    fill: "#4060FF"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 177.252H140.732V180.199H152.967V177.252Z",
    fill: "#4060FF"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0527 177.252C93.7896 177.62 94.4895 178.029 95.1858 178.427V177.252H93.0527Z",
    fill: "#4060FF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M110.368 177.252H107.42V180.199H110.368V177.252Z",
    fill: "#4060FF"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 177.252H122.603V180.199H125.55V177.252Z",
    fill: "#4060FF"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 177.252H137.785V180.199H140.732V177.252Z",
    fill: "#4060FF"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 177.252H152.967V180.199H155.915V177.252Z",
    fill: "#4060FF"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M155.914 196.77H156.397C156.397 195.816 156.397 194.829 156.422 193.823H155.914V196.77Z",
    fill: "#4060FF"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M137.785 193.823H125.55V196.77H137.785V193.823Z",
    fill: "#4060FF"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M122.603 193.823H113.596C115.001 194.869 116.446 195.852 117.932 196.77H122.607L122.603 193.823Z",
    fill: "#4060FF"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 193.823H140.732V196.77H152.967V193.823Z",
    fill: "#4060FF"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M125.55 193.823H122.603V196.77H125.55V193.823Z",
    fill: "#4060FF"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 193.823H137.785V196.77H140.732V193.823Z",
    fill: "#4060FF"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M155.915 193.823H152.967V196.77H155.915V193.823Z",
    fill: "#4060FF"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1077 77.7333C107.002 86.9878 118.194 99.44 116.802 105.246C113.077 120.771 78.5976 143.756 78.5976 143.756L62.6196 137.943L66.1674 131.779L96.4987 104.17C96.4987 104.17 79.6918 95.067 76.9508 92.3813C60.1513 75.9797 77.8608 66.0805 94.1077 77.7333Z",
    fill: "#8B4500"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8215 131.061C59.978 134.859 49.8246 133.54 51.1804 136.756C52.2598 139.335 65.4526 137.655 65.4526 137.655L67.8215 131.061Z",
    fill: "#8B4500"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4405 136.311C57.3695 144.331 54.588 153.357 57.3327 153.81C60.0774 154.263 66.4398 137.968 66.4398 137.968L61.4405 136.311Z",
    fill: "#8B4500"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2777 137.847C62.2252 145.867 59.4253 154.897 62.17 155.35C64.9146 155.803 71.2771 139.508 71.2771 139.508L66.2777 137.847Z",
    fill: "#8B4500"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7749 155.074C59.3823 153.305 60.318 149.319 63.91 141.748L64.9084 142.224C63.7148 144.74 60.0823 152.406 61.6443 154.381L60.7749 155.074Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0272 139.059C66.9747 147.079 64.1747 156.105 66.9157 156.558C69.6567 157.011 76.0191 140.731 76.0191 140.731L71.0272 139.059Z",
    fill: "#8B4500"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M65.523 156.282C64.1304 154.514 65.0662 150.531 68.6545 142.96L69.6566 143.432C68.4592 145.952 64.8267 153.615 66.3925 155.59L65.523 156.282Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1565 140.437C71.7819 147.61 69.3872 156.894 72.1356 157.262C74.8839 157.63 79.8722 143.086 79.8722 143.086L75.1565 140.437Z",
    fill: "#8B4500"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M70.78 157.041C69.0632 155.04 70.2532 151.047 72.891 144.832L73.9078 145.263C71.5684 150.789 70.2864 154.768 71.62 156.315L70.78 157.041Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M50.731 76.0718C56.3383 76.0718 55.5204 73.3971 55.5204 65.7784C55.5204 58.1597 55.8593 56.4797 62.6233 55.7097C69.3874 54.9398 69.1995 51.2557 71.9773 46.6542C74.7551 42.0528 79.0508 44.6574 81.8138 47.4205C83.5114 49.1404 84.9252 51.1188 86.0027 53.2819C86.0027 53.2819 70.0247 61.678 66.1859 65.5205C57.8266 73.8797 58.4124 76.0939 56.6588 79.8185C52.4478 88.7562 35.571 85.3741 30.9658 83.2337L50.731 76.0718Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1774 90.6571C32.1774 90.6571 41.045 78.4996 50.7452 76.0718C50.7452 76.0718 51.4194 69.8088 41.0892 67.0973C30.759 64.3858 22.6687 74.9702 19.7988 66.9168C16.9288 58.8633 7.3907 56.7339 7.3907 56.7339L6.31494 58.8044C6.31494 58.8044 13.65 58.0417 13.4547 67.6462C13.3 75.1949 15.8126 78.8864 22.2524 79.4574C28.6922 80.0285 32.1774 90.6571 32.1774 90.6571Z",
    fill: "#9747FF"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01858 61.5525C10.0085 61.5525 11.6216 59.9394 11.6216 57.9495C11.6216 55.9596 10.0085 54.3464 8.01858 54.3464C6.02867 54.3464 4.41553 55.9596 4.41553 57.9495C4.41553 59.9394 6.02867 61.5525 8.01858 61.5525Z",
    fill: "#FF7C5E"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M135.391 180.582C146.368 180.582 155.267 171.684 155.267 160.707C155.267 149.729 146.368 140.831 135.391 140.831C124.414 140.831 115.516 149.729 115.516 160.707C115.516 171.684 124.414 180.582 135.391 180.582Z",
    fill: "#121020"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M124.405 172.592C135.13 180.568 146.551 176.913 152.574 172.429C152.978 172.135 153.476 171.997 153.974 172.042C154.472 172.087 154.937 172.311 155.282 172.673C155.475 172.874 155.626 173.113 155.724 173.374C155.823 173.635 155.867 173.914 155.855 174.193C155.842 174.472 155.773 174.746 155.652 174.997C155.531 175.249 155.36 175.473 155.149 175.657C152.939 177.547 146.462 181.452 138.593 181.036C124.66 180.299 119.564 168.749 119.564 168.749L124.405 172.592Z",
    fill: "#121020"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M155.057 159.421C154.765 158.666 153.916 158.291 153.162 158.583C152.408 158.875 152.034 159.724 152.326 160.48L154.926 167.189C155.218 167.944 156.067 168.319 156.821 168.027C157.575 167.734 157.949 166.885 157.657 166.13L155.057 159.421Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M153.262 162.66C152.97 161.905 152.121 161.529 151.367 161.821C150.613 162.114 150.239 162.963 150.531 163.718L153.131 170.427C153.423 171.182 154.272 171.557 155.026 171.265C155.78 170.973 156.154 170.124 155.862 169.369L153.262 162.66Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M149.049 165.971L151.223 167.766L152.218 165.128L149.049 165.971Z",
    fill: "#FF7C5E"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M151.739 155.099C155.541 154.731 157.394 155.468 157.394 155.468C156.937 157.501 155.83 159.33 154.24 160.677L151.739 155.099Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M181.889 88.4172C173.825 103.01 173.607 110.463 172.167 120.259C187.795 117.584 193.601 128.754 193.601 128.754L181.889 88.4172Z",
    fill: "#4060FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error-404.9ab1184de5895be230403aa1c98ef9ab.svg";
export { ForwardRef as ReactComponent };